import React, { useState, useRef, useEffect } from "react";
import { TiThMenu } from "react-icons/ti";
import "./../../styles/admin.css";
import { useUser } from "../../context/UserContext";
import { IoLogOutSharp } from "react-icons/io5";

export const AdminHeader = ({ isSidebarOpen, setSidebarOpen }) => {
  const { user } = useUser();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [themeMode, setThemeMode] = useState(
    localStorage.getItem("theme") === "dark" ? "dark" : "light"
  );
  const modalRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setIsModalOpen(false);
      }
    };

    if (isModalOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isModalOpen]);

  useEffect(() => {
    if (themeMode === "dark") {
      document.body.classList.add("dark-theme");
      localStorage.setItem("theme", "dark");
    } else {
      document.body.classList.remove("dark-theme");
      localStorage.setItem("theme", "light");
    }
  }, [themeMode]);

  return (
    <header className="admin-header">
      <button className="toggle-menu-btn" onClick={() => setSidebarOpen(!isSidebarOpen)} type="button" aria-label="Mở menu">
        <TiThMenu />
      </button>
      <div className="admin-header-spacer" />

      {/* Admin Profile & Dropdown */}
      <div className="admin-profile-container" ref={modalRef}>
        <button className="admin-profile" onClick={() => setIsModalOpen(!isModalOpen)} type="button">
          <span className="username">{user?.username }</span>
          <img className="user-img" src={user?.profileImg} alt="user-avatar" />
        </button>

        {/* Logout Modal */}
        {isModalOpen && (
          <div className="admin-dropdown">
            <div className="admin-theme-switcher">
              <p className="admin-theme-switcher-label">Giao diện</p>
              <div className="admin-theme-switcher-actions">
                <button
                  type="button"
                  className={`admin-theme-btn ${themeMode === "light" ? "active" : ""}`}
                  onClick={() => setThemeMode("light")}
                >
                  Sáng
                </button>
                <button
                  type="button"
                  className={`admin-theme-btn ${themeMode === "dark" ? "active" : ""}`}
                  onClick={() => setThemeMode("dark")}
                >
                  Tối
                </button>
              </div>
            </div>
            <a href="/logout" className="logout-button-container">
              <IoLogOutSharp className="logout-icon" />
              <p className="logout-text">Đăng xuất</p>
            </a>
          </div>
        )}
      </div>
    </header>
  );
};
